/**
 * Created by shubham on 16/4/18.
 */

import { NgModule} from '@angular/core';
import { Http} from '@angular/http';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { AddEditUserComponent } from './add-edit-user/add-edit-user.component';
import {TranslateModule,TranslateLoader,TranslateStaticLoader} from 'ng2-translate';
import { APPCONFIG } from '../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMultiSelectModule,
        UserRoutingModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+'/_ah/api/noAuthApi/v1/i18nJson', ''),
            deps: [Http]
        })
    ],
    declarations: [
        UserComponent,
        AddEditUserComponent
    ],
    exports: [

    ]
})

export class UserModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user/user.module.ts